// Action Types for KPI Goal Management

// Fetch all goals with pagination
export const FETCH_GOALS = 'kpiGoal/FETCH_GOALS';
export const FETCH_GOALS_SUCCESS = 'kpiGoal/FETCH_GOALS_SUCCESS';
export const FETCH_GOALS_FAILURE = 'kpiGoal/FETCH_GOALS_FAILURE';

// Fetch goal by ID
export const FETCH_GOAL_BY_ID = 'kpiGoal/FETCH_GOAL_BY_ID';
export const FETCH_GOAL_BY_ID_SUCCESS = 'kpiGoal/FETCH_GOAL_BY_ID_SUCCESS';
export const FETCH_GOAL_BY_ID_FAILURE = 'kpiGoal/FETCH_GOAL_BY_ID_FAILURE';

// Create goal
export const CREATE_GOAL = 'kpiGoal/CREATE_GOAL';
export const CREATE_GOAL_SUCCESS = 'kpiGoal/CREATE_GOAL_SUCCESS';
export const CREATE_GOAL_FAILURE = 'kpiGoal/CREATE_GOAL_FAILURE';

// Update goal
export const UPDATE_GOAL = 'kpiGoal/UPDATE_GOAL';
export const UPDATE_GOAL_SUCCESS = 'kpiGoal/UPDATE_GOAL_SUCCESS';
export const UPDATE_GOAL_FAILURE = 'kpiGoal/UPDATE_GOAL_FAILURE';

// Delete goal
export const DELETE_GOAL = 'kpiGoal/DELETE_GOAL';
export const DELETE_GOAL_SUCCESS = 'kpiGoal/DELETE_GOAL_SUCCESS';
export const DELETE_GOAL_FAILURE = 'kpiGoal/DELETE_GOAL_FAILURE';

// Dialog management
export const OPEN_GOAL_DIALOG = 'kpiGoal/OPEN_GOAL_DIALOG';
export const CLOSE_GOAL_DIALOG = 'kpiGoal/CLOSE_GOAL_DIALOG';
export const OPEN_DELETE_DIALOG = 'kpiGoal/OPEN_DELETE_DIALOG';
export const CLOSE_DELETE_DIALOG = 'kpiGoal/CLOSE_DELETE_DIALOG';

// Set selected goal
export const SET_SELECTED_GOAL = 'kpiGoal/SET_SELECTED_GOAL';

// Set filters and pagination
export const SET_FILTERS = 'kpiGoal/SET_FILTERS';
export const SET_PAGINATION = 'kpiGoal/SET_PAGINATION';
export const SET_SORT = 'kpiGoal/SET_SORT';

// Goal usage dialog
export const OPEN_GOAL_USAGE_DIALOG = 'kpiGoal/OPEN_GOAL_USAGE_DIALOG';
export const CLOSE_GOAL_USAGE_DIALOG = 'kpiGoal/CLOSE_GOAL_USAGE_DIALOG';

// Fetch departments
export const FETCH_DEPARTMENTS = 'kpiGoal/FETCH_DEPARTMENTS';
export const FETCH_DEPARTMENTS_SUCCESS = 'kpiGoal/FETCH_DEPARTMENTS_SUCCESS';
export const FETCH_DEPARTMENTS_FAILURE = 'kpiGoal/FETCH_DEPARTMENTS_FAILURE';
